import { create } from 'zustand';

/**
 * Types
 */
import type { PageContainerProps, ProLayoutProps } from '@ant-design/pro-components';

type LayoutStore = {
    layout: ProLayoutProps;
    pageContainer: PageContainerProps;
    setLayout: (layout: ProLayoutProps) => void;
    setPageContainer: (pageContainer: PageContainerProps) => void;
};

export const useLayoutStore = create<LayoutStore>((set) => ({
    layout: {},
    pageContainer: {},
    setLayout: (layout) => set({ layout }),
    setPageContainer: (pageContainer) => set({ pageContainer }),
}));
